import React, { useState } from 'react';
import { KPIDashboard } from '../components/manager/KPIDashboard';
import { Leaderboard } from '../components/admin/Leaderboard';
import { ManagerHierarchy } from '../components/admin/ManagerHierarchy';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { useData } from '../context/DataContext';
import { exportReviewsToCsv } from '../utils/exportReport';
import { HealthIndicator } from '../data/mockData';
import { cn } from '../components/ui/Card';
import { X } from 'lucide-react';
export function AdminView() {
  const {
    loanOfficers,
    managers,
    selectedWeek
  } = useData();
  const [healthFilter, setHealthFilter] = useState<HealthIndicator | 'all'>('all');
  const toggleFilter = (h: HealthIndicator) => setHealthFilter(prev => prev === h ? 'all' : h);
  const handleExport = () => exportReviewsToCsv(loanOfficers, managers, selectedWeek, 'organization-accountability-report');
  const healthyCount = loanOfficers.filter(lo => lo.healthIndicator === 'Healthy').length;
  const atRiskCount = loanOfficers.filter(lo => lo.healthIndicator === 'At Risk').length;
  const criticalCount = loanOfficers.filter(lo => lo.healthIndicator === 'Critical').length;
  const total = loanOfficers.length;
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-311">
      <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-312">
        <div data-id="element-313">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-314">
            Executive Command Center
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-315">
            Organization-wide accountability and coaching oversight.
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex space-x-3" data-id="element-316">
          <button onClick={handleExport} className="px-4 py-2 bg-white border border-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-50" data-id="element-317">
            Export Report
          </button>
        </div>
      </div>

      {/* Org-wide KPIs */}
      <KPIDashboard data-id="element-318" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-319">
        <Leaderboard data-id="element-320" />

        <Card data-id="element-321">
          <CardHeader data-id="element-322">
            <CardTitle data-id="element-323">Org Coaching Health</CardTitle>
          </CardHeader>
          <CardContent data-id="element-324">
            <p className="text-xs text-slate-400 mb-4" data-id="element-325">
              Click a band to filter the hierarchy below.
            </p>
            <div className="space-y-3" data-id="element-326">
              {[{
              key: 'Healthy' as HealthIndicator,
              count: healthyCount,
              bar: 'bg-emerald-500',
              ring: 'ring-emerald-500'
            }, {
              key: 'At Risk' as HealthIndicator,
              count: atRiskCount,
              bar: 'bg-amber-500',
              ring: 'ring-amber-500'
            }, {
              key: 'Critical' as HealthIndicator,
              count: criticalCount,
              bar: 'bg-rose-500',
              ring: 'ring-rose-500'
            }].map(band => <button key={band.key} onClick={() => toggleFilter(band.key)} aria-pressed={healthFilter === band.key} className={cn('w-full text-left rounded-lg p-2 -m-2 transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-1', healthFilter === band.key ? `bg-slate-50 ring-2 ring-offset-1 ${band.ring}` : 'ring-0')} data-id="element-327">
                  <div className="flex justify-between text-sm mb-1" data-id="element-328">
                    <span className="font-medium text-slate-700" data-id="element-329">
                      {band.key}
                    </span>
                    <span className="text-slate-500" data-id="element-330">
                      {band.count}/{total}
                    </span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-2.5" data-id="element-331">
                    <div className={`${band.bar} h-2.5 rounded-full`} style={{
                  width: `${total > 0 ? band.count / total * 100 : 0}%`
                }} data-id="element-332"></div>
                  </div>
                </button>)}
            </div>
            <div className="mt-8 p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-333">
              <h4 className="text-sm font-semibold text-slate-900 mb-2" data-id="element-334">
                Top Coaching Gap
              </h4>
              <p className="text-sm text-slate-600" data-id="element-335">
                Organization-wide,{' '}
                <span className="font-bold text-slate-900" data-id="element-336">Game Films</span> has
                the lowest completion rate (42%).
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="mt-8" data-id="element-337">
        <div className="flex items-center justify-between mb-4" data-id="element-338">
          <h2 className="text-lg font-semibold text-slate-900" data-id="element-339">
            Manager Hierarchy & Reviews
          </h2>
          {healthFilter !== 'all' && <button onClick={() => setHealthFilter('all')} className="inline-flex items-center space-x-1.5 text-sm font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-full px-3 py-1 transition-colors" data-id="element-340">
              <span data-id="element-341">
                Filtered by{' '}
                <span className="font-semibold text-slate-900" data-id="element-342">
                  {healthFilter}
                </span>
              </span>
              <X className="w-3.5 h-3.5" data-id="element-343" />
            </button>}
        </div>
        <ManagerHierarchy healthFilter={healthFilter} data-id="element-344" />
      </div>
    </div>;
}